import React, { Component } from "react";
import axios from "axios";
import {
  Button,
  TextField,
  Typography,
  Box,
  Card,
  CardContent,
  CardActionArea,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Serverurl from "./Apiurl";
import Fab from '@mui/material/Fab';
import { NavLink, Navigate } from 'react-router-dom';
import Addproduct from "./Addproduct";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


class Invoiceproducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      page: 0,
      rowsPerPage: 5,
      totalItems: 0,
      searchName: "",
      addProductOpen: false,
    };
  }

  componentDidMount() {
    this.fetchProducts();
  }

  fetchProducts = () => {
    const bu_id = localStorage.getItem("GBuserid");

    axios.get(
      Serverurl +
      "ajaxproduct.php?action=getall&StartIndex=" +
      this.state.page +
      "&PageSize=" +
      this.state.rowsPerPage +
      "&pr_name=" +
      this.state.searchName +
      "&pr_bu_id=" +
      bu_id
    )
    .then((res) => {
      this.setState({
        products: res.data,
        totalItems: parseInt(res.data[0]?.total || 0)
      });
    });
  };

  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchProducts);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value),
        page: 0
      },
      this.fetchProducts
    );
  };

  handleSearchChange = (e) => {
    this.setState({ searchName: e.target.value });
  };

  searchProducts = () => {
    this.setState({ page: 0 }, this.fetchProducts);
  };

  render() {
    return (
      <div className="formdisplay">

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
            mb: 2,
            whiteSpace: "nowrap",
          }}
        >

          <ChevronLeftIcon
            className="global-back-arrow"
            onClick={() => window.history.back()}
          />

          <Typography variant="h4">
            Products
          </Typography>

        </Box>


        <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>

          <TextField
            variant="outlined"
            size="small"
            placeholder="Enter Product Name..."
            sx={{
              borderRadius: '50px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '50px',
                border: '0.5px solid #c0c0c0',
                padding: '3px 0px !important',
                paddingRight: '4px',
                '& fieldset': {
                  borderColor: '#e2e8f0',
                },
                '&:hover fieldset': {
                  borderColor: '#cbd5e1 !important',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#11408f !important',
                },
              },
              '& .MuiOutlinedInput-input': {
                paddingLeft: '20px !important',
                fontSize: '14px',
              },
            }}
            value={this.state.searchName}
            onChange={this.handleSearchChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                this.searchProducts();
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">

                  <IconButton
                    onClick={this.searchProducts}
                    sx={{
                      backgroundColor: '#11408f',
                      color: '#ffffff',
                      width: '56px',
                      marginRight: '0px',
                      padding: '12px',
                      '&:hover': {
                        backgroundColor: '#0d3476',
                      },
                    }}
                    edge="end"
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>

                </InputAdornment>
              ),
            }}
          />

        </Box>


        {this.state.products.map((p) => (

          <Card key={p.pr_id} sx={{ mb: 2 }}>

            <CardActionArea
              onClick={() => this.props.onSelectProduct(p)}
            >

              <CardContent>

                <Typography variant="h6">
                  {p.pr_name}
                </Typography>

                <Typography variant="subtitle1">
                  ₹ {p.pr_price}
                </Typography>

                <Typography variant="body2">
                  GST: {p.pr_gst}%
                </Typography>

              </CardContent>

            </CardActionArea>

          </Card>

        ))}


        {this.state.totalItems > 0 && (

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.onPageChange}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.onRowsPerPageChange}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />

        )}


        {/* Floating Add Button */}

        <Fab
          onClick={() => this.setState({ addProductOpen: true })}
          aria-label="add"
          sx={{
            position: 'fixed',
            bottom: 30,
            right: 30,
            zIndex: 1000,
            backgroundColor: '#11408f',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#0d3476',
            },
          }}
        >
          Add
        </Fab>


        <Dialog
          open={this.state.addProductOpen}
          onClose={() =>
            this.setState({ addProductOpen: false })
          }
          fullWidth
          maxWidth="md"
        >

          <DialogContent sx={{ padding: '10px 5px' }}>

            <Addproduct
              invoiceMode={true}
              onProductAdded={(product) => {

                this.setState({
                  addProductOpen: false
                });

                this.props.onSelectProduct(product);

              }}
            />

          </DialogContent>

        </Dialog>

      </div>
    );
  }
}

export default Invoiceproducts;
